module.exports = __webpack_public_path__ + "img/49.64059222.png";